module.exports = __webpack_public_path__ + "img/ep-3-dosis.bf0f913f.jpg";